import { isEmpty } from '../utils/validations';
import { UserCompletedData } from './user-completed-data';

export class User {
    public id: number;
    public email: string;
    public name: string;
    public firstSurname: string;
    public secondSurname: string;
    public completedSteps: UserCompletedData;

    constructor(object?: any) {
        object = object ? object : {};
        this.id = isEmpty(object.id) ? null : Number(object.id);
        this.email = isEmpty(object.correo) ? null : object.correo;
        this.name = isEmpty(object.nombre) ? null : object.nombre;
        this.firstSurname = isEmpty(object.apellido_paterno) ? null : object.apellido_paterno;
        this.secondSurname = isEmpty(object.apellido_materno) ? null : object.apellido_materno;
        this.completedSteps = isEmpty(object.completedSteps) ? new UserCompletedData() : new UserCompletedData(object.completedSteps);
    }

    get completeRequiredData(): boolean {
        return this.completedSteps.phoneVerification.completed
        && this.completedSteps.businessData.completed
        && this.completedSteps.accountData.completed;
    }
}
